import { RewardItem } from "../../pages/Referral/context/types";

export const ambassador: { stats: RewardItem[] } = {
  stats: [
    {
      VE: "123",
      Cashback: "0",
      RefLvl1: "123",
      RefLvl2: "123",
      Followers: "123",
      Total: "0.123/$100",
      Balance: "0.123/$100",
      ProtocolEarn: "123",
    },
    {
      VE: "123",
      Cashback: "0",
      RefLvl1: "123",
      RefLvl2: "123",
      Followers: "123",
      Total: "0.123/$100",
      Balance: "0.123/$100",
      ProtocolEarn: "123",
    },
    {
      VE: "123",
      Cashback: "0",
      RefLvl1: "123",
      RefLvl2: "123",
      Followers: "123",
      Total: "0.123/$100",
      Balance: "0.123/$100",
      ProtocolEarn: "123",
    },
    {
      VE: "123",
      Cashback: "0",
      RefLvl1: "123",
      RefLvl2: "123",
      Followers: "123",
      Total: "0.123/$100",
      Balance: "0.123/$100",
      ProtocolEarn: "123",
    },
    {
      VE: "123",
      Cashback: "0",
      RefLvl1: "123",
      RefLvl2: "123",
      Followers: "123",
      Total: "0.123/$100",
      Balance: "0.123/$100",
      ProtocolEarn: "123",
    },
    {
      VE: "123",
      Cashback: "0",
      RefLvl1: "123",
      RefLvl2: "123",
      Followers: "123",
      Total: "0.123/$100",
      Balance: "0.123/$100",
      ProtocolEarn: "123",
    },
    {
      VE: "123",
      Cashback: "0",
      RefLvl1: "123",
      RefLvl2: "123",
      Followers: "123",
      Total: "0.123/$100",
      Balance: "0.123/$100",
      ProtocolEarn: "123",
    },
    {
      VE: "123",
      Cashback: "0",
      RefLvl1: "123",
      RefLvl2: "123",
      Followers: "123",
      Total: "0.123/$100",
      Balance: "0.123/$100",
      ProtocolEarn: "123",
    },
    {
      VE: "123",
      Cashback: "0",
      RefLvl1: "123",
      RefLvl2: "123",
      Followers: "123",
      Total: "0.123/$100",
      Balance: "0.123/$100",
      ProtocolEarn: "123",
    },
    {
      VE: "123",
      Cashback: "0",
      RefLvl1: "123",
      RefLvl2: "123",
      Followers: "123",
      Total: "0.123/$100",
      Balance: "0.123/$100",
      ProtocolEarn: "123",
    },
    {
      VE: "123",
      Cashback: "0",
      RefLvl1: "123",
      RefLvl2: "123",
      Followers: "123",
      Total: "0.123/$100",
      Balance: "0.123/$100",
      ProtocolEarn: "123",
    },
    {
      VE: "123",
      Cashback: "0",
      RefLvl1: "123",
      RefLvl2: "123",
      Followers: "123",
      Total: "0.123/$100",
      Balance: "0.123/$100",
      ProtocolEarn: "123",
    },
    {
      VE: "123",
      Cashback: "0",
      RefLvl1: "123",
      RefLvl2: "123",
      Followers: "123",
      Total: "0.123/$100",
      Balance: "0.123/$100",
      ProtocolEarn: "123",
    },
  ],
};
